<template>
  <base-account>
    <section class="section hero-section bg-ico-hero" id="home">
      <div class="bg-overlay bg-primary"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Criar Conta</h5>
                      <p>Crie uma conta para acessar o sistema de NFS-e</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div role="alert" v-show="resposta.status" aria-live="polite" aria-atomic="true"
                     class="alert alert-success mt-2">
                  <i class="mdi mdi-check-all mr-2"></i> {{ resposta.mensagem }}
                </div>
                <div role="alert" v-show="resposta.status === false" aria-live="polite" aria-atomic="true"
                     class="alert alert-danger mt-2">
                  <i class="mdi mdi-block-helper mr-2"></i> {{ resposta.mensagem }}
                </div>
                <Loader :loading="httpSend">
                  <b-form v-show="resposta.status !== true" class="p-2" @submit.prevent="tryToRegisterIn">
                    <b-form-group
                        id="email-group"
                        label="CPF"
                        label-for="username">
                      <input
                          id="username"
                          autocomplete="no"
                          v-mask="'###.###.###-##'"
                          v-model="user.pes_cpfcnpj"
                          type="text"
                          placeholder="CPF (Somente números)"
                          class="form-control"
                          :class="{'is-invalid': (submitted && $v.user.pes_cpfcnpj.$error) || cpfInvalido}">
                      <div v-if="submitted && !$v.user.pes_cpfcnpj.required"
                           class="invalid-feedback">
                        Informe seu CPF
                      </div>
                      <div v-if="cpfInvalido"
                           class="invalid-feedback">
                        CPF inválido
                      </div>
                    </b-form-group>

                    <b-form-group id="fullname-group" label="E-mail" label-for="email">
                      <input
                          id="email"
                          autocomplete="no"
                          v-model="user.pes_mail"
                          type="email"
                          class="form-control"
                          placeholder="Informe seu e-mail"
                          :class="{ 'is-invalid': submitted && $v.user.pes_mail.$error }">
                      <div v-if="submitted && $v.user.pes_mail.$error" class="invalid-feedback">
                        <span v-if="!$v.user.pes_mail.required">Informe seu e-mail</span>
                        <span v-if="!$v.user.pes_mail.email">E-mail inválido.</span>
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="password-group"
                        label="Senha"
                        label-for="password">
                      <div class="input-group mb-3">
                        <input
                            id="password"
                            autocomplete="no"
                            v-model="user.aut_senha"
                            v-bind:type="showPassword?'text':'password'"
                            class="form-control"
                            placeholder="Utilize letras, números e caracteres especiais"
                            :class="{
                    'is-invalid': submitted && $v.user.aut_senha.$error,
                  }">
                        <div class="input-group-append">
                          <label class="input-group-text">
                            <a style="cursor: pointer" @click="altershowPassword()" class="is-link">
                              <i v-show="!showPassword" class="fa fa-eye-slash" aria-hidden="true"></i>
                              <i v-show="showPassword" class="fa fa-eye" aria-hidden="true"></i>
                            </a>
                          </label>
                        </div>
                      </div>
                      <div v-show="user.aut_senha" class="mt-2 progress">
                        <div role="progressbar" v-show="passwordStrength.score <= 5" aria-valuemin="0"
                             aria-valuemax="30"
                             aria-valuenow="27" class="progress-bar bg-danger" style="width: 30%;">Péssima
                        </div>
                        <div role="progressbar" v-show="passwordStrength.score > 2" aria-valuemin="0" aria-valuemax="35"
                             aria-valuenow="35" class="progress-bar bg-warning" style="width: 35%;">Fraca
                        </div>
                        <div role="progressbar" v-show="passwordStrength.score > 3" aria-valuemin="0" aria-valuemax="35"
                             aria-valuenow="7" class="progress-bar bg-success" style="width: 35%;">Boa
                        </div>
                      </div>
                      <div v-if="submitted && !$v.user.aut_senha.required" class="invalid-feedback">
                        Informe uma senha.
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="password-reply-group"
                        label="Repita sua senha"
                        label-for="password">
                      <div class="input-group mb-3">
                        <input
                            id="password-reply"
                            autocomplete="no"
                            v-model="user.aut_senha_reply"
                            v-bind:type="showPassword?'text':'password'"
                            class="form-control"
                            placeholder=""
                            :class="{'is-invalid': submitted && $v.user.aut_senha_reply.$error,}">
                        <div class="input-group-append">
                          <label class="input-group-text">
                            <a style="cursor: pointer" @click="altershowPassword()" class="is-link">
                              <i v-show="!showPassword" class="fa fa-eye-slash" aria-hidden="true"></i>
                              <i v-show="showPassword" class="fa fa-eye" aria-hidden="true"></i>
                            </a>
                          </label>
                        </div>
                      </div>
                      <div v-show="senhaDiferentes" class="text-danger">
                        As senhas não coincidem
                      </div>
                    </b-form-group>

                    <div class="mt-4">
                      <b-button type="submit" :disabled="passwordStrength.score < 3 || $v.user.$invalid"
                                variant="primary"
                                class="btn-block">Criar Conta
                      </b-button>
                    </div>

                  </b-form>
                </Loader>
              </div>
            </div>
            <div class="mt-5 text-center text-white">
              <p>
                Já possui conta ?
                <router-link
                    tag="a"
                    to="/"
                    class="font-weight-medium text-danger">Login
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </base-account>
</template>
<script>
const zxcvbn = require('zxcvbn');
import {validaCpfCnpj} from "@/helps/util";
import appConfig from "@/dados/app.config.json";
import Loader from "@/components/widgets/loader"
import {setUsuario} from "@/api/login/auth"
import {required, email} from "vuelidate/lib/validators";
import BaseAccount from "@/router/layouts/base-account"

export default {
  page: {
    title: "Register",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    BaseAccount,
    Loader,
  },
  data() {
    return {
      entidade: {},
      user: {
        pes_cpfcnpj: "",
        pes_mail: "",
        aut_senha: "",
        aut_senha_reply: "",
        dominio: window.location.origin,
      },
      resposta: {
        status: null,
        mensagem: ''
      },
      httpSend: false,
      submitted: false,
      cpfInvalido: false,
      showPassword: false
    };
  },
  validations: {
    user: {
      pes_cpfcnpj: {
        required,
      },
      pes_mail: {
        required,
        email,
      },
      aut_senha: {
        required,
      },
      aut_senha_reply: {
        required,
      },
    },
  },
  computed: {
    passwordStrength() {
      return zxcvbn(this.user.aut_senha);
    },
    senhaDiferentes() {
      return (this.user.aut_senha !== this.user.aut_senha_reply);
    }
  },
  methods: {
    altershowPassword() {
      this.showPassword = !this.showPassword;
    },
    tryToRegisterIn() {
      this.submitted = true;
      this.cpfInvalido = false;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (validaCpfCnpj(this.user.pes_cpfcnpj)) {
        this.httpSend = true;
        setUsuario(this.user).then(response => {
          this.resposta = response
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.httpSend = false
        })
      } else {
        this.cpfInvalido = true;
        return
      }
    },
  },
};
</script>


<style lang="scss" module></style>
